export const ADD_CURSOR = 'data:image/png;base64,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';
export const DELETE_CURSOR = 'data:image/png;base64,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';
export const NOT_ALLOWED_CURSOR = 'data:image/png;base64,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';

export const NOT_ALLOWED_CLASS = 'io-cursor-not-allowed-CHFG';
export const ADD_CLASS = 'io-cursor-add-CHFG';
export const DELETE_CLASS = 'io-cursor-delete-CHFG';

export const CURSOR_STYLES = `

.${NOT_ALLOWED_CLASS} {
  cursor: url(${NOT_ALLOWED_CURSOR}) 0 0, auto !important;
}


.${ADD_CLASS} {
  cursor: url(${ADD_CURSOR}) 0 0, auto !important;
}


.${DELETE_CLASS} {
  cursor: url(${DELETE_CURSOR}) 0 0, auto !important;
}

`;

/**
 * CSS class name for record highlights.
 * @type string
 */
export const RECORD_HIGHLIGHT_CLASS_NAME = '_iohighlight-record';

/**
 * CSS class name for field highlights.
 * @type string
 */
export const EXAMPLE_HIGHLIGHT_CLASS_NAME = '_iohighlight-field';

/**
 * CSS class name for anti field highlights.
 * @type string
 */
export const COUNTEREXAMPLE_HIGHLIGHT_CLASS_NAME = '_iohighlight-counter';

/**
 * CSS class name for hover highlights.
 * @type string
 */
export const HOVER_HIGHLIGHT_CLASS_NAME = '_iohighlight-hover';

/**
 * CSS class name for suggestion highlights.
 * @type string
 */
export const SUGGESTION_HIGHLIGHT_CLASS_NAME = '_iohighlight-fieldsuggest';

/**
 * CSS class name for data highlights.
 * @type string
 */
export const DATA_HIGHLIGHT_CLASS_NAME = '_iohighlight-data';

export const OVERLAY_CLASS_NAME = '_iohighlight-overlay';

/**
 * CSS style definition for record highlight.
 * @type string
 */
export const RECORD_HIGHLIGHT_STYLE = `.${RECORD_HIGHLIGHT_CLASS_NAME} { outline: 2px solid red !important; }`;

/**
 * CSS style definition for overlay.
 * @type string
 */
export const OVERLAY_STYLE = `
  div.${OVERLAY_CLASS_NAME} {
    position: absolute;
    margin: 0;
    padding: 0;
    pointer-events: none;
  }`;

/**
 * CSS style definition for field highlight.
 * @type string
 */
export const GREEN_HIGHLIGHT = 'rgba(60, 147, 51, 1)';
export const PINK_HIGHLIGHT = 'rgba(255, 38, 170, 1)';
export const EXAMPLE_HIGHLIGHT_STYLE = `
  div.${EXAMPLE_HIGHLIGHT_CLASS_NAME} {
    outline : 3px solid ${GREEN_HIGHLIGHT} !important;
    z-index: 16777270;
  }`;

/**
 * CSS style definition for field highlight.
 * @type string
 */
export const COUNTEREXAMPLE_HIGHLIGHT_STYLE = `
  div.${COUNTEREXAMPLE_HIGHLIGHT_CLASS_NAME} {
    /*outline : 3px solid #001760 !important;*/
    z-index: 16777270;
  }`;

/**
 * CSS style definition for field highlight.
 * @type string
 */
export const DATA_HIGHLIGHT_STYLE = `
  div.${DATA_HIGHLIGHT_CLASS_NAME} {
    outline : 3px solid ${GREEN_HIGHLIGHT} !important;
    z-index: 16777269;
  }`;

/**
 * CSS style definition for hover highlight.
 * @type string
 */
export const HOVER_HIGHLIGHT_STYLE = `
  div.${HOVER_HIGHLIGHT_CLASS_NAME}{
    outline : 1px solid ${PINK_HIGHLIGHT} !important;
    z-index: 16777271;
  }`;

/**
 * CSS style definition for suggestion highlight.
 * @type string
 */
export const SUGGESTION_HIGHLIGHT_STYLE = `
  div.${SUGGESTION_HIGHLIGHT_CLASS_NAME}{
    outline : 3px solid rgba(102, 194, 206, 0.5) !important;
    z-index: 16777269;
}
`;

export const DRAW_SUGGESTIONS = false;

export const WEBSITE_VIEW_MESSAGE_MAP = {
  CAPTURE_LINK: 'webpage_view_include_link_confirm_modal',
  CLEAR_AND_TRAIN: 'webpage_view_clear_column_train_modal',
};
